'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dKind from "./presto.types$-Directive-Kind.js";
import * as $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412 from "./presto.types$-Directive-Kind$$anon$12.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveKind$$anon$15(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveKind$$anon$15 as $c_Lpresto_types$DirectiveKind$$anon$15 };
$p = $c_Lpresto_types$DirectiveKind$$anon$15.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveKind$$anon$15;
/** @constructor */
function $h_Lpresto_types$DirectiveKind$$anon$15() {
}
export { $h_Lpresto_types$DirectiveKind$$anon$15 as $h_Lpresto_types$DirectiveKind$$anon$15 };
$h_Lpresto_types$DirectiveKind$$anon$15.prototype = $p;
$p.bO = (function(text) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$DirectiveKind$().cxs(text));
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
    }
  }
});
$p.cBM = (function(it) {
  try {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(it.l());
  } catch (e) {
    var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
    if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
    } else {
      throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
    }
  }
});
$p.bK = (function(t) {
  return this.cBM(t);
});
var $d_Lpresto_types$DirectiveKind$$anon$15 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveKind$$anon$15, "presto.types$DirectiveKind$$anon$15", ({
  ZJ: 1,
  K: 1
}));
export { $d_Lpresto_types$DirectiveKind$$anon$15 as $d_Lpresto_types$DirectiveKind$$anon$15 };
function $s_Lpresto_types$DirectiveKind$__Highlight__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__Highlight;
}
export { $s_Lpresto_types$DirectiveKind$__Highlight__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__Highlight__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__AddStyle__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__AddStyle;
}
export { $s_Lpresto_types$DirectiveKind$__AddStyle__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__AddStyle__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes;
}
export { $s_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__BlockEntirePage__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__BlockEntirePage;
}
export { $s_Lpresto_types$DirectiveKind$__BlockEntirePage__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__BlockEntirePage__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__ChangeBackgroundColor__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__ChangeBackgroundColor;
}
export { $s_Lpresto_types$DirectiveKind$__ChangeBackgroundColor__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__ChangeBackgroundColor__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__DisableElement__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__DisableElement;
}
export { $s_Lpresto_types$DirectiveKind$__DisableElement__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__DisableElement__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__RemoveAttribute__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__RemoveAttribute;
}
export { $s_Lpresto_types$DirectiveKind$__RemoveAttribute__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__RemoveAttribute__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__RemoveElement__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__RemoveElement;
}
export { $s_Lpresto_types$DirectiveKind$__RemoveElement__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__RemoveElement__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals;
}
export { $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals;
}
export { $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals__Lpresto_types$DirectiveKind };
function $s_Lpresto_types$DirectiveKind$__ReplaceElement__Lpresto_types$DirectiveKind() {
  $m_Lpresto_types$DirectiveKind$();
  return $t_Lpresto_types$DirectiveKind$__ReplaceElement;
}
export { $s_Lpresto_types$DirectiveKind$__ReplaceElement__Lpresto_types$DirectiveKind as $s_Lpresto_types$DirectiveKind$__ReplaceElement__Lpresto_types$DirectiveKind };
/** @constructor */
function $c_Lpresto_types$DirectiveKind$() {
  this.c6j = null;
  this.c6m = null;
  this.c6n = false;
  this.c6k = null;
  this.c6l = false;
  this.c6q = null;
  this.c6r = false;
  this.c6o = null;
  this.c6p = false;
  this.c6s = null;
  this.c6t = false;
  $n_Lpresto_types$DirectiveKind$ = this;
  $t_Lpresto_types$DirectiveKind$__Highlight = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(0, "Highlight", this);
  $t_Lpresto_types$DirectiveKind$__AddStyle = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(1, "AddStyle", this);
  $t_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(2, "AddDefaultBlockAttributes", this);
  $t_Lpresto_types$DirectiveKind$__BlockEntirePage = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(3, "BlockEntirePage", this);
  $t_Lpresto_types$DirectiveKind$__ChangeBackgroundColor = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(4, "ChangeBackgroundColor", this);
  $t_Lpresto_types$DirectiveKind$__DisableElement = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(5, "DisableElement", this);
  $t_Lpresto_types$DirectiveKind$__RemoveAttribute = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(6, "RemoveAttribute", this);
  $t_Lpresto_types$DirectiveKind$__RemoveElement = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(7, "RemoveElement", this);
  $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(8, "RemoveElementIfTextEquals", this);
  $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(9, "RemoveElementIfTextNotEquals", this);
  $t_Lpresto_types$DirectiveKind$__ReplaceElement = new $j_presto$002etypes$0024$002dDirective$002dKind$0024$0024anon$002412.$c_Lpresto_types$DirectiveKind$$anon$12(10, "ReplaceElement", this);
  this.c6j = new ($j_presto$002etypes$0024$002dDirective$002dKind.$d_Lpresto_types$DirectiveKind.r().C)([$s_Lpresto_types$DirectiveKind$__Highlight__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__AddStyle__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__BlockEntirePage__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__ChangeBackgroundColor__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__DisableElement__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__RemoveAttribute__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__RemoveElement__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals__Lpresto_types$DirectiveKind(), $s_Lpresto_types$DirectiveKind$__ReplaceElement__Lpresto_types$DirectiveKind()]);
}
export { $c_Lpresto_types$DirectiveKind$ as $c_Lpresto_types$DirectiveKind$ };
$p = $c_Lpresto_types$DirectiveKind$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveKind$;
/** @constructor */
function $h_Lpresto_types$DirectiveKind$() {
}
export { $h_Lpresto_types$DirectiveKind$ as $h_Lpresto_types$DirectiveKind$ };
$h_Lpresto_types$DirectiveKind$.prototype = $p;
$p.cSe = (function() {
  return this.c6j.at();
});
$p.cxs = (function(\u03b4name) {
  switch (\u03b4name) {
    case "Highlight": {
      return $s_Lpresto_types$DirectiveKind$__Highlight__Lpresto_types$DirectiveKind();
      break;
    }
    case "AddStyle": {
      return $s_Lpresto_types$DirectiveKind$__AddStyle__Lpresto_types$DirectiveKind();
      break;
    }
    case "AddDefaultBlockAttributes": {
      return $s_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes__Lpresto_types$DirectiveKind();
      break;
    }
    case "BlockEntirePage": {
      return $s_Lpresto_types$DirectiveKind$__BlockEntirePage__Lpresto_types$DirectiveKind();
      break;
    }
    case "ChangeBackgroundColor": {
      return $s_Lpresto_types$DirectiveKind$__ChangeBackgroundColor__Lpresto_types$DirectiveKind();
      break;
    }
    case "DisableElement": {
      return $s_Lpresto_types$DirectiveKind$__DisableElement__Lpresto_types$DirectiveKind();
      break;
    }
    case "RemoveAttribute": {
      return $s_Lpresto_types$DirectiveKind$__RemoveAttribute__Lpresto_types$DirectiveKind();
      break;
    }
    case "RemoveElement": {
      return $s_Lpresto_types$DirectiveKind$__RemoveElement__Lpresto_types$DirectiveKind();
      break;
    }
    case "RemoveElementIfTextEquals": {
      return $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals__Lpresto_types$DirectiveKind();
      break;
    }
    case "RemoveElementIfTextNotEquals": {
      return $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals__Lpresto_types$DirectiveKind();
      break;
    }
    case "ReplaceElement": {
      return $s_Lpresto_types$DirectiveKind$__ReplaceElement__Lpresto_types$DirectiveKind();
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IllegalArgumentException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IllegalArgumentException(), ("enum case not found: " + \u03b4name));
    }
  }
});
$p.cIZ = (function() {
  if ((!this.c6n)) {
    this.c6m = new $c_Lpresto_types$DirectiveKind$$anon$13(this);
    this.c6n = true;
  }
  return this.c6m;
});
$p.vh = (function() {
  if ((!this.c6l)) {
    this.c6k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$14(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
      try {
        return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success($m_Lpresto_types$DirectiveKind$().cxs(str));
      } catch (e) {
        var e$2 = ((e instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Throwable) ? e : new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException(e));
        if ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_control_NonFatal$().al(e$2)) {
          return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(e$2);
        } else {
          throw ((e$2 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjs_js_JavaScriptException) ? e$2.a8 : e$2);
        }
      }
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9);
    this.c6l = true;
  }
  return this.c6k;
});
$p.cJJ = (function() {
  if ((!this.c6r)) {
    this.c6q = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((it) => this.cq4(it))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c6r = true;
  }
  return this.c6q;
});
$p.ct0 = (function() {
  if ((!this.c6p)) {
    this.c6o = new $c_Lpresto_types$DirectiveKind$$anon$14(this);
    this.c6p = true;
  }
  return this.c6o;
});
$p.ctf = (function() {
  if ((!this.c6t)) {
    this.c6s = new $c_Lpresto_types$DirectiveKind$$anon$15(this);
    this.c6t = true;
  }
  return this.c6s;
});
$p.cq4 = (function(it) {
  var x = $s_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes__Lpresto_types$DirectiveKind();
  if ((x === it)) {
    return "atributos padr\u00e3o de bloqueio";
  }
  var x$3 = $s_Lpresto_types$DirectiveKind$__AddStyle__Lpresto_types$DirectiveKind();
  if ((x$3 === it)) {
    return "adicionar estilo";
  }
  var x$5 = $s_Lpresto_types$DirectiveKind$__BlockEntirePage__Lpresto_types$DirectiveKind();
  if ((x$5 === it)) {
    return "bloquear p\u00e1gina";
  }
  var x$7 = $s_Lpresto_types$DirectiveKind$__ChangeBackgroundColor__Lpresto_types$DirectiveKind();
  if ((x$7 === it)) {
    return "mudar cor de fundo";
  }
  var x$9 = $s_Lpresto_types$DirectiveKind$__DisableElement__Lpresto_types$DirectiveKind();
  if ((x$9 === it)) {
    return "desabilitar";
  }
  var x$11 = $s_Lpresto_types$DirectiveKind$__Highlight__Lpresto_types$DirectiveKind();
  if ((x$11 === it)) {
    return "destacar";
  }
  var x$13 = $s_Lpresto_types$DirectiveKind$__RemoveAttribute__Lpresto_types$DirectiveKind();
  if ((x$13 === it)) {
    return "remover atributo";
  }
  var x$15 = $s_Lpresto_types$DirectiveKind$__RemoveElement__Lpresto_types$DirectiveKind();
  if ((x$15 === it)) {
    return "remover";
  }
  var x$17 = $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals__Lpresto_types$DirectiveKind();
  if ((x$17 === it)) {
    return "remover se o texto for igual";
  }
  var x$19 = $s_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals__Lpresto_types$DirectiveKind();
  if ((x$19 === it)) {
    return "remover se o texto for diferente";
  }
  var x$21 = $s_Lpresto_types$DirectiveKind$__ReplaceElement__Lpresto_types$DirectiveKind();
  if ((x$21 === it)) {
    return "substituir";
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(it);
});
$p.cBF = (function() {
  var $x_3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Map$();
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_Predef$();
  var xs = $m_Lpresto_types$DirectiveKind$().cSe();
  var evidence$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_reflect_ClassTag$().qV($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$objectGetClass(xs).aU.Q());
  var capacity = 0;
  var size = 0;
  var jsElems = null;
  var elementClass = evidence$1.fl();
  capacity = 0;
  size = 0;
  var isCharArrayBuilder = (elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_C.l());
  jsElems = [];
  var i = 0;
  while ((i < xs.b.length)) {
    var x1 = i;
    var x = xs.b[x1];
    var x$2 = $s_Lpresto_types$DirectiveKind$__Highlight__Lpresto_types$DirectiveKind();
    if ((!((x === null) ? (x$2 === null) : (x === x$2)))) {
      var unboxedElem = (isCharArrayBuilder ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uC(x) : ((x === null) ? elementClass.aU.z : x));
      jsElems.push(unboxedElem);
    }
    i = ((1 + i) | 0);
  }
  var elemRuntimeClass = ((elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_V.l()) ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_jl_Void.l() : (((elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_sr_Null$.l()) || (elementClass === $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_sr_Nothing$.l())) ? $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_O.l() : elementClass));
  var xs$1 = elemRuntimeClass.aU.r().w(jsElems);
  var len = xs$1.b.length;
  var ys = new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_T2.r().C)(len);
  if ((len > 0)) {
    var i$1 = 0;
    while ((i$1 < len)) {
      var $x_1 = i$1;
      var arg1 = xs$1.b[i$1];
      ys.b[$x_1] = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(arg1, this.cq4(arg1));
      i$1 = ((1 + i$1) | 0);
    }
  }
  return $x_3.b6($x_2.et(ys));
});
var $d_Lpresto_types$DirectiveKind$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveKind$, "presto.types$DirectiveKind$", ({
  ZF: 1,
  e: 1,
  G: 1
}));
export { $d_Lpresto_types$DirectiveKind$ as $d_Lpresto_types$DirectiveKind$ };
var $n_Lpresto_types$DirectiveKind$;
function $m_Lpresto_types$DirectiveKind$() {
  if ((!$n_Lpresto_types$DirectiveKind$)) {
    $n_Lpresto_types$DirectiveKind$ = new $c_Lpresto_types$DirectiveKind$();
  }
  return $n_Lpresto_types$DirectiveKind$;
}
export { $m_Lpresto_types$DirectiveKind$ as $m_Lpresto_types$DirectiveKind$ };
/** @constructor */
function $c_Lpresto_types$DirectiveKind$$anon$13(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveKind$$anon$13 as $c_Lpresto_types$DirectiveKind$$anon$13 };
$p = $c_Lpresto_types$DirectiveKind$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveKind$$anon$13;
/** @constructor */
function $h_Lpresto_types$DirectiveKind$$anon$13() {
}
export { $h_Lpresto_types$DirectiveKind$$anon$13 as $h_Lpresto_types$DirectiveKind$$anon$13 };
$h_Lpresto_types$DirectiveKind$$anon$13.prototype = $p;
$p.a1 = (function(a) {
  $m_Lpresto_types$DirectiveKind$();
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Json$();
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Json$JString(a.l());
});
var $d_Lpresto_types$DirectiveKind$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveKind$$anon$13, "presto.types$DirectiveKind$$anon$13", ({
  ZH: 1,
  a: 1,
  l: 1
}));
export { $d_Lpresto_types$DirectiveKind$$anon$13 as $d_Lpresto_types$DirectiveKind$$anon$13 };
/** @constructor */
function $c_Lpresto_types$DirectiveKind$$anon$14(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveKind$$anon$14 as $c_Lpresto_types$DirectiveKind$$anon$14 };
$p = $c_Lpresto_types$DirectiveKind$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$DirectiveKind$$anon$14;
/** @constructor */
function $h_Lpresto_types$DirectiveKind$$anon$14() {
}
export { $h_Lpresto_types$DirectiveKind$$anon$14 as $h_Lpresto_types$DirectiveKind$$anon$14 };
$h_Lpresto_types$DirectiveKind$$anon$14.prototype = $p;
$p.cD = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cs = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.ct = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cK = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cB = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  $m_Lpresto_types$DirectiveKind$();
  var this$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_RichInt(x.aa5);
  var y$1 = y.aa5;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_Ordering$Int$();
  var x$2 = this$3.uR;
  return ((x$2 === y$1) ? 0 : ((x$2 < y$1) ? (-1) : 1));
});
var $d_Lpresto_types$DirectiveKind$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveKind$$anon$14, "presto.types$DirectiveKind$$anon$14", ({
  ZI: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$DirectiveKind$$anon$14 as $d_Lpresto_types$DirectiveKind$$anon$14 };
var $t_Lpresto_types$DirectiveKind$__Highlight = null;
function $u_Lpresto_types$DirectiveKind$__Highlight(x) {
  $t_Lpresto_types$DirectiveKind$__Highlight = x;
}
export { $t_Lpresto_types$DirectiveKind$__Highlight as $t_Lpresto_types$DirectiveKind$__Highlight, $u_Lpresto_types$DirectiveKind$__Highlight as $u_Lpresto_types$DirectiveKind$__Highlight };
var $t_Lpresto_types$DirectiveKind$__AddStyle = null;
function $u_Lpresto_types$DirectiveKind$__AddStyle(x) {
  $t_Lpresto_types$DirectiveKind$__AddStyle = x;
}
export { $t_Lpresto_types$DirectiveKind$__AddStyle as $t_Lpresto_types$DirectiveKind$__AddStyle, $u_Lpresto_types$DirectiveKind$__AddStyle as $u_Lpresto_types$DirectiveKind$__AddStyle };
var $t_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes = null;
function $u_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes(x) {
  $t_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes = x;
}
export { $t_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes as $t_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes, $u_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes as $u_Lpresto_types$DirectiveKind$__AddDefaultBlockAttributes };
var $t_Lpresto_types$DirectiveKind$__BlockEntirePage = null;
function $u_Lpresto_types$DirectiveKind$__BlockEntirePage(x) {
  $t_Lpresto_types$DirectiveKind$__BlockEntirePage = x;
}
export { $t_Lpresto_types$DirectiveKind$__BlockEntirePage as $t_Lpresto_types$DirectiveKind$__BlockEntirePage, $u_Lpresto_types$DirectiveKind$__BlockEntirePage as $u_Lpresto_types$DirectiveKind$__BlockEntirePage };
var $t_Lpresto_types$DirectiveKind$__ChangeBackgroundColor = null;
function $u_Lpresto_types$DirectiveKind$__ChangeBackgroundColor(x) {
  $t_Lpresto_types$DirectiveKind$__ChangeBackgroundColor = x;
}
export { $t_Lpresto_types$DirectiveKind$__ChangeBackgroundColor as $t_Lpresto_types$DirectiveKind$__ChangeBackgroundColor, $u_Lpresto_types$DirectiveKind$__ChangeBackgroundColor as $u_Lpresto_types$DirectiveKind$__ChangeBackgroundColor };
var $t_Lpresto_types$DirectiveKind$__DisableElement = null;
function $u_Lpresto_types$DirectiveKind$__DisableElement(x) {
  $t_Lpresto_types$DirectiveKind$__DisableElement = x;
}
export { $t_Lpresto_types$DirectiveKind$__DisableElement as $t_Lpresto_types$DirectiveKind$__DisableElement, $u_Lpresto_types$DirectiveKind$__DisableElement as $u_Lpresto_types$DirectiveKind$__DisableElement };
var $t_Lpresto_types$DirectiveKind$__RemoveAttribute = null;
function $u_Lpresto_types$DirectiveKind$__RemoveAttribute(x) {
  $t_Lpresto_types$DirectiveKind$__RemoveAttribute = x;
}
export { $t_Lpresto_types$DirectiveKind$__RemoveAttribute as $t_Lpresto_types$DirectiveKind$__RemoveAttribute, $u_Lpresto_types$DirectiveKind$__RemoveAttribute as $u_Lpresto_types$DirectiveKind$__RemoveAttribute };
var $t_Lpresto_types$DirectiveKind$__RemoveElement = null;
function $u_Lpresto_types$DirectiveKind$__RemoveElement(x) {
  $t_Lpresto_types$DirectiveKind$__RemoveElement = x;
}
export { $t_Lpresto_types$DirectiveKind$__RemoveElement as $t_Lpresto_types$DirectiveKind$__RemoveElement, $u_Lpresto_types$DirectiveKind$__RemoveElement as $u_Lpresto_types$DirectiveKind$__RemoveElement };
var $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals = null;
function $u_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals(x) {
  $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals = x;
}
export { $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals as $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals, $u_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals as $u_Lpresto_types$DirectiveKind$__RemoveElementIfTextEquals };
var $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals = null;
function $u_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals(x) {
  $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals = x;
}
export { $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals as $t_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals, $u_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals as $u_Lpresto_types$DirectiveKind$__RemoveElementIfTextNotEquals };
var $t_Lpresto_types$DirectiveKind$__ReplaceElement = null;
function $u_Lpresto_types$DirectiveKind$__ReplaceElement(x) {
  $t_Lpresto_types$DirectiveKind$__ReplaceElement = x;
}
export { $t_Lpresto_types$DirectiveKind$__ReplaceElement as $t_Lpresto_types$DirectiveKind$__ReplaceElement, $u_Lpresto_types$DirectiveKind$__ReplaceElement as $u_Lpresto_types$DirectiveKind$__ReplaceElement };
//# sourceMappingURL=presto.types$-Directive-Kind$.js.map
